import { useParams } from "react-router-dom";
import ReasonCode from '../ReasonCode/Confirm'
import WorkCenterConfirm from '../WorkCenter/Confirm'
import RecordPicklist from '../RecordPicklist'
import ExtraCompoent from '../ExtraComponent'
import EditBatchNo from '../EditBatchNo'
import RetainRecord from '../RetainRecord'
import { useState, useEffect, useContext, useCallback } from "react";
import { DataStore, SortDirection } from '@aws-amplify/datastore'
import ProductionOrderHeader from '../../ProductionOrderHeader'
import { DgtPdOrderOperation, DgtPdOrderReasonCode } from '../../../models'
import { Documents, MainMenuAdmin, OrderStatusCode, OrderStatusTheme, OrderStatusForAdminDisplay, OrderStatusDisplay } from '../../../constants/Enum'
import OrderContext from '../../../contexts/OrderContext'
import SyncExpressionContext from '../../../contexts/SyncExpressionContext'
import RecordTimeTypeContext from '../../../contexts/RecordTimeTypeContext'
import MovementContext from '../../../contexts/MovementContext'
import OrderReceiptContext from "../../../contexts/OrderReceiptContext";
import { syncQueriesReady, removeSync } from '../../../sync/DataStoreSync'
import SpinnerLoading from "../../../components/SpinnerLoading"
import TabMenu from "../../../components/TabMenu";
import Comment from '../../../components/Comment'
import UserContext from '../../../contexts/UserContext'
import Modal from '../../../components/Modal'
import Badge from '../../../components/Badge'
import { 
	getRemotePicklistById,
	postComment,
	getMovementsById,
	getOrderReceipts,
	updateStatusComment
} from '../../../states/PicklistAction'

import {
	getOrder,
	updateDivision,
	updateStatus,
	updateActualBatchNo
} from '../../../apis/order'
import { convertJson } from '../../../utilities/Validate'
import PicklistContext from "../../../contexts/PicklistContext";
import { getDataStoreOperations } from "../../../apis";

const ProductionProcessConfirm = () => {
	const { id } = useParams()
	const { user, readOnly } = useContext(UserContext)

	const { order, setOrder } = useContext(OrderContext)
	const { setSyncOrderID } = useContext(SyncExpressionContext)

	const [currentMenu, setCurrentMenu] = useState('operation')
	const [operations, setOperations] = useState([])
	const [reasonCodes, setReasonCodes] = useState([])
	const [ movements, setMovements ] = useState([])
	const [ picklistHeader, setPicklistHeader ] = useState()
	const [ picklistItems, setPicklistItems ] = useState([])
	const [ picklistComments, setPicklistComments ] = useState([])
	const [ orderReceipts, setOrderReceipts ] = useState([])

	const [currentTimeType, setCurrentTimeType] = useState('');
  	const valueCurrentTimeType = { currentTimeType, setCurrentTimeType };

	const [showSelectOperation, setShowSelectOperation] = useState(false)
	const [selectOperation, setSelectOperation] = useState([])
	const [errorSelectOperation, setErrorSelectOperation] = useState('')
	const [statusOnChange, setStatusOnChange] = useState('')
	const [clearSelectStatus, setClearSelectStatus] = useState(false)

	const username = user?.name || user?.givenName || user?.username || ''

	const mutateHeader = (updatedHeader) => {
		setPicklistHeader(updatedHeader)
	}

	const mutateMovements = (updatedMovements) => {
		setMovements(movements.map(mv => {
			const found = updatedMovements.find(updated => updated.sk === mv.sk)
			return found || mv
		}))
	}

	const mutateOrderReceipt = (updatedOrderReceipt) => {
		setOrderReceipts(orderReceipts.map(log => 
      log.productionOrderId === updatedOrderReceipt.productionOrderId &&
			log.batchLotNo === updatedOrderReceipt.batchLotNo
			? updatedOrderReceipt : log))
	}

	const mutateOrderReceipts = (updatedOrderReceipts) => {
		setOrderReceipts(updatedOrderReceipts)
	}

	const onTabSelected = (key) => {
		setCurrentMenu(key)
	}

	const pleaseRefresh = async () => {
		try {
			const operations = await getDataStoreOperations(id)
			const reasonCodes = await DataStore.query(DgtPdOrderReasonCode,
				rc => rc.productionOrderId('eq', id), { sort: rc => rc.materialCode(SortDirection.ASCENDING) })
			updateConfirmedToOrder(operations, reasonCodes)
		} catch (error) {
			console.log("Error retrieving ProductionOrders", error);
		}
	}

	const updateConfirmedToOrder = async (latestWorkCenters, latestReasonCodes) => {
		const activeOperations = latestWorkCenters.filter(op => op.active)
		const countOfOpConfirmed = activeOperations.reduce((prev, cur) => prev +
		(cur.status && cur.status === OrderStatusCode.CONFIRMED), 0)
			const draftedReasonCodes = latestReasonCodes.filter(res => res.confirmStatus === OrderStatusCode.DRAFTED)
		if (countOfOpConfirmed === activeOperations.length && draftedReasonCodes.length === 0) {
			const updated = await updateStatus(order.id, OrderStatusCode.CONFIRMED)
			setOrder(updated)
		}
  }

	useEffect(() => {
		const fetchPdProcess = async () => {
			try {
				const operations = await getDataStoreOperations(id)
				setOperations(operations)

				const reasonCodes = await DataStore.query(DgtPdOrderReasonCode,
					rc => rc.productionOrderId('eq', id), { sort: rc => rc.materialCode(SortDirection.ASCENDING) })
				setReasonCodes(reasonCodes)
			} catch (error) {
				console.log("Error retrieving ProductionOrders", error);
			}
		}
		const listener1 = syncQueriesReady(fetchPdProcess, null)
		return () => {
      removeSync(listener1)
    }
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		setSyncOrderID(id)

		const fetchOrder = async (pdOrdId) => {
			try {
				const order = await getOrder(pdOrdId)
				setOrder(order)
			} catch (error) {
				console.log("Error retrieving ProductionOrder", error);
			}
		}

		const fetchPicklistItems = async (orderId) => {
			const picklists = await getRemotePicklistById(orderId)
			const { header, items, comments } = picklists
			setPicklistHeader(header)
			setPicklistItems(items)
			setPicklistComments(comments)
		}

		const fetchMovements = async (orderId) => {
			const mvs = await getMovementsById(orderId)
      setMovements(mvs.filter(itm => itm.movementType !== '262'))
		}

		const fetchOrderReceipts = async (orderId) => {
			const orderReceipts =  await getOrderReceipts(orderId)
			setOrderReceipts(orderReceipts)
		}

		fetchOrder(id)

		fetchPicklistItems(id)

		fetchMovements(id)

		fetchOrderReceipts(id)
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	const onPostComment = useCallback(async (comment) => {
    const commentResponse = await postComment(id, comment, username)
    setPicklistComments([...picklistComments, commentResponse])
  }, [ id, username, picklistComments ])

	const onActiveComment = useCallback(async (orderId: string, skCommentId: string, active: boolean, version: number) => {
		const updatedComment = await updateStatusComment(orderId, skCommentId, active, version)
		setPicklistComments(picklistComments.map(comment => comment.sk === skCommentId ? updatedComment : comment))
	}, [ picklistComments, setPicklistComments ])
	
	const renderBody = () => {
		if (operations.length === 0) return <SpinnerLoading />

		if (currentMenu === 'operation') {
			return <RecordTimeTypeContext.Provider value={valueCurrentTimeType}>
				<WorkCenterConfirm workCenters={operations} order={order} setOrder={setOrder} pleaseRefresh={pleaseRefresh} operationRefresh={operationRefresh}/>
			</RecordTimeTypeContext.Provider>
		} else if (currentMenu === 'reason_code') {
			return <ReasonCode reasonCodes={reasonCodes} pleaseRefresh={pleaseRefresh}/>
		} else if (currentMenu === 'picklist') {
			return <RecordPicklist header={picklistHeader}
				materialItems={picklistItems.filter(item => (item.withdrawQty || 0) >= 0 || item.materialType === 'BULK' || item.materialDescription === 'DIW')}
				username={username}
				isAdmin={true}
				readOnly={readOnly}
			/>
		} else if (currentMenu === 'comment') {
			return <Comment 
				comments={picklistComments.sort((a, b) => a.sk.localeCompare(b.sk))} 
				onPost={onPostComment}
				onActive={onActiveComment}
				username={username}
			/>
		} else if (currentMenu === 'extra') {
			return <ExtraCompoent 
				orderNo={id}
				username={username}
				status={null} dateRange={null} keyword={id}
				readOnly={readOnly}
			/>
		} else if (currentMenu === 'edit_batch_no') {
			let batchNumbers = []
			if (order) {
				if (order.actualBatchNumbers) {
					const originalBatch = order.batchNumbers ? convertJson(order.batchNumbers) : []
					const mergedBatch = [...convertJson(order.actualBatchNumbers), ...originalBatch]
					mergedBatch.forEach(batch => {
						const sixLastDigit = batch.slice(-6)
						if (!batchNumbers.map(b => b.slice(-6)).includes(sixLastDigit)) {
							batchNumbers.push(batch)
						}
					})
				} else if (order.batchNumbers) {
					batchNumbers = convertJson(order.batchNumbers)
				}
			}
			return <EditBatchNo
				batchNumbers={batchNumbers}
				onUpdateCompleted={onUpdateBatchNoCompleted}
				onSkiped={onSkipUpdateBatchNo}
				isEmptyLot={order && order.batchNumbers === '[]'}
			/>
		}
		else if (currentMenu === 'retain_record') {
			return <RetainRecord disabledInput={readOnly} canDelete={true} canEditBulk={true} />
		}
	}

	const onUpdateBatchNoCompleted = useCallback((updatedOrder) => {
		if (updatedOrder) setOrder(updatedOrder)

		setCurrentMenu('operation')
	}, [ setOrder])

	const onSkipUpdateBatchNo = useCallback(() => {
		setCurrentMenu('operation')
	}, [])

	const divisionOnChanged = async (e) => {
		const updated = await updateDivision(order.id, e.currentTarget.value)
		setOrder(updated)
	}

	const onStatusChanged = async (status = '') => {
		await handleUpdateStatusOperation(status ? status : statusOnChange)
		await operationRefresh()
		const updated = await updateStatus(order.id, status ? status : statusOnChange)
		setOrder(updated)
	}
	
	const operationRefresh = async () => {
		try {
			const operations = await getDataStoreOperations(id)
			setOperations(operations)
		} catch (error) {
			console.log("Error operationRefresh", error);
		}
	}

	const handleOnStatusChanged = async (status) => {
		setStatusOnChange(status)
		const allowStatusManualModal = [
			OrderStatusCode.READY,
			OrderStatusCode.IN_PROGRESS,
			OrderStatusCode.DRAFTED,
			OrderStatusCode.CONFIRMED
		]
		if(allowStatusManualModal.includes(status)){
			setShowSelectOperation(true)
		}else{
			await onStatusChanged(status)
		}
	}

	const onConfirmSelectOperation = async () => {
		if(Array.isArray(selectOperation) && selectOperation.length > 0){
			await onStatusChanged(statusOnChange)
			setShowSelectOperation(false)
		}else{
			setErrorSelectOperation('กรุณาเลือก Operation')
		}
	}

	const handleUpdateStatusOperation = async (status) => {
		switch(status) {
			case OrderStatusCode.READY:
				await updateOperationToReady()
				break;
			case OrderStatusCode.IN_PROGRESS:
				await updateOperationToInprogress()
				break;
			case OrderStatusCode.DRAFTED:
				await updateOperationToDrafted()
				break;
			case OrderStatusCode.CONFIRMED:
				await updateOperationToConfirmed()
				break;
			default:
				break;
		}
	}
	
	const updateOperationToReady = async () => {
		try {
			const opIds = operations.filter((value) => selectOperation.includes(value.operationNo)).map((value) => value.id)
			for (const opId of opIds) {
				const originalOperation = await DataStore.query(DgtPdOrderOperation, opId)
				if (originalOperation) {
					const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
						updated.status = OrderStatusCode.READY
					})
					await DataStore.save(updateOperation)
				}
			}
			
			// post comment
			const comment = `Manual Change Order Status From "${OrderStatusDisplay[order.statusFromApp]}" To "${OrderStatusDisplay[OrderStatusCode.READY]}" | By.${user?.name || user?.username}`
			const username = "System"
			await postComment(id, comment, username)
		} catch (error) {
			console.log(error)
		}
	}

	const updateOperationToInprogress = async () => {
		try {
			const opIds = operations.filter((value) => selectOperation.includes(value.operationNo)).map((value) => value.id)
			for (const opId of opIds) {
				const originalOperation = await DataStore.query(DgtPdOrderOperation, opId)
				if (originalOperation) {
					const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
						updated.status = OrderStatusCode.IN_PROGRESS
					})
					await DataStore.save(updateOperation)
				}
			}
			
			// post comment
			const comment = `Manual Change Order Status From "${OrderStatusDisplay[order.statusFromApp]}" To "${OrderStatusDisplay[OrderStatusCode.IN_PROGRESS]}" | By.${user?.name || user?.username}`
			const username = "System"
			await postComment(id, comment, username)
		} catch (error) {
			console.log(error)
		}
	}

	const updateOperationToDrafted = async () => {
		try {
			const opIds = operations.filter((value) => selectOperation.includes(value.operationNo)).map((value) => value.id)
			for (const opId of opIds) {
				const originalOperation = await DataStore.query(DgtPdOrderOperation, opId)
				if (originalOperation) {
					const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
						updated.status = OrderStatusCode.DRAFTED
					})
					await DataStore.save(updateOperation)
				}
			}

			// post comment
			const comment = `Manual Change Order Status From "${OrderStatusDisplay[order.statusFromApp]}" To "${OrderStatusDisplay[OrderStatusCode.DRAFTED]}" | By.${user?.name || user?.username}`
			const username = "System"
			await postComment(id, comment, username)
		} catch (error) {
			console.log(error)
		}
	}

	const updateOperationToConfirmed = async () => {
		try {
			const opIds = operations.filter((value) => selectOperation.includes(value.operationNo)).map((value) => value.id)
			for (const opId of opIds) {
				const originalOperation = await DataStore.query(DgtPdOrderOperation, opId)
				if (originalOperation) {
					const updateOperation = DgtPdOrderOperation.copyOf(originalOperation, updated => {
						updated.status = OrderStatusCode.CONFIRMED
					})
					await DataStore.save(updateOperation)
				}
			}

			// post comment
			const comment = `Manual Change Order Status From "${OrderStatusDisplay[order.statusFromApp]}" To "${OrderStatusDisplay[OrderStatusCode.CONFIRMED]}" | By.${user?.name || user?.username}`
			const username = "System"
			await postComment(id, comment, username)
		} catch (error) {
			console.log(error)
		}
	}

	const onBatchChanged = async (updatedBatches) => {
		const updated = await updateActualBatchNo(order.id, updatedBatches)
		setOrder(updated)
	}

	const onModalSelectedOperation = (key) => {
		if(selectOperation.find(data=>data===key)){
			setSelectOperation(selectOperation.filter(data=>data!==key))
		}else{
			setSelectOperation([...selectOperation, key])
		}
	}

	const handleCancelModalSelectOperation = () => {
		setClearSelectStatus(true)
		setShowSelectOperation(false)
	}
	
	useEffect(() => {
		setErrorSelectOperation('')
	}, [selectOperation])

	useEffect(() => {
		if(showSelectOperation === true){
			setSelectOperation([])
		}
	}, [showSelectOperation])
	
	const bodyModalSelectOperation = () => {
		return (
			<span className="list-group-horizontal">
				{operations.map(wc =>
					<button key={wc.operationNo}
						className={`list-item-horizontal ${selectOperation.find(data=>data===wc.operationNo) ? ' bg-blue-100 border-blue-600':''}`}
						onClick={() => onModalSelectedOperation(wc.operationNo)}
					>
					<div className="flex items-center justify-center gap-2">
						<input
							type="checkbox"
							className='w-full h-full'
							style={{width:'25px', height:'25px'}}
							checked={selectOperation.find(data=>data===wc.operationNo) | false}
							readOnly={true}
						/>
						<h6><Badge variant={OrderStatusTheme[wc.status]}>{OrderStatusForAdminDisplay[wc.status]}</Badge></h6>
						<h6 className={`${selectOperation.find(data=>data===wc.operationNo) ? ' text-blue-600':' text-gray-600'}`}>{`Op No: ${wc.operationNo} `}</h6>
						<h6 className={`${selectOperation.find(data=>data===wc.operationNo) ? ' text-blue-600':' text-gray-600'}`}>{`WC: ${wc.actualWorkCenterDescription ? wc.actualWorkCenterDescription : wc.workCenterDescription} (${wc.actualWorkCenterId ? wc.actualWorkCenterId : wc.workCenterId})`}</h6>
					</div>
					</button>
				)}
			</span>
		)
	}

	return order ? <div className="mx-5 mt-2">
		<ProductionOrderHeader id={id} productionOrder={order} title={Documents.PRODUCTION_PROCESS_CONFIRM}
			divisionOnChanged={divisionOnChanged} onStatusChanged={handleOnStatusChanged} onBatchChanged={onBatchChanged}
			readOnly={readOnly} clearSelectStatus={clearSelectStatus} setClearSelectStatus={setClearSelectStatus}
			picklist={picklistHeader}/>
		{currentTimeType === '' && <TabMenu
			menus={MainMenuAdmin}
			onChanged={(idx) => onTabSelected(MainMenuAdmin[idx].value)}
			selectedIndex={MainMenuAdmin.findIndex(m => m.value === currentMenu)}
			isEmptyReason={reasonCodes.length === 0}
		/>}
		<PicklistContext.Provider value={{ 
			items: picklistItems, header: picklistHeader, comments: picklistComments, mutateHeader }}>
			<MovementContext.Provider value={{ movements, mutateMovements }}>
				<OrderReceiptContext.Provider value={{ orderReceipts, mutateOrderReceipt, mutateOrderReceipts }}>
					{renderBody()}
				</OrderReceiptContext.Provider>
			</MovementContext.Provider>
		</PicklistContext.Provider>
		<Modal
			show={showSelectOperation}
			disableClickOutsite={true}
			fullWidth={true}
			onHide={() => setShowSelectOperation(false)}
			title={`เลือก Operation ที่จะเปลี่ยนเป็นสถานะ "${OrderStatusDisplay[statusOnChange]}"`}
			body={bodyModalSelectOperation()}
			cancelAction={handleCancelModalSelectOperation}
			cancelText='ยกเลิก'
			okAction={onConfirmSelectOperation}
			children={errorSelectOperation ? <div className="mt-5 mb-5"><h5 style={{color:'red'}}>{errorSelectOperation}</h5></div> : null}
			okText='ยืนยัน'
			okTheme='success'
		/>
	</div> : <SpinnerLoading />
}

export default ProductionProcessConfirm